import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomInterfacePlaceholderDirective } from "src/directive/custom-interface-placeholder.directive";
import { CustomInterfaceSingleComponentListPlaceholderDirective } from "./custom-interface-single-component-list-placeholder.directive";
import { StructureTableAnagraph_TableDirective } from "./structure-table-anagraph-table.directive";
import { StructureTableAnagraph_AnagraphDirective } from "./structure-table-anagraph-anagraph.directive";
import { FilterTablePlaceholderDirective } from "./filter-table-placeholder.directive";
import { IconHoverDirective } from "./icon-hover-directive";
import { FillViewportRowsDirective } from "./fill-viewport-rows.directive";

@NgModule({
  declarations: [
    CustomInterfacePlaceholderDirective,
    CustomInterfaceSingleComponentListPlaceholderDirective,
    StructureTableAnagraph_TableDirective,
    StructureTableAnagraph_AnagraphDirective,
    FilterTablePlaceholderDirective,
    IconHoverDirective,
    FillViewportRowsDirective,
  ],
  imports: [CommonModule],
  exports: [
    CustomInterfacePlaceholderDirective,
    CustomInterfaceSingleComponentListPlaceholderDirective,
    StructureTableAnagraph_TableDirective,
    StructureTableAnagraph_AnagraphDirective,
    FilterTablePlaceholderDirective,
    IconHoverDirective,
    FillViewportRowsDirective,
  ],
})
export class CommonDirectiveModule { }
